import React from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  launchIconBtnContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  launchIcon: {
    fontSize: '1rem',
    cursor: 'pointer',
  }
};

const LaunchValuationButton = ({ classes, rowData, handleViewValuation, color }) => {

  const launchValuation = () => {
    handleViewValuation(rowData);
  };
  return (
    <div className={classes.launchIconBtnContainer}>
      <LaunchIcon className={classes.launchIcon} onClick={launchValuation} color={color} />
    </div>
  );
};

export default withStyles(styles)(LaunchValuationButton);